import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  listContainer: {
    paddingLeft: theme.spacing(3),
  },
}))

export default styles
